const errorMessageCodeMap = new Map([
  ['failed to fetch', 'connection'],
  ['network error', 'connection'],
  ['fetch failed', 'connection'],
])
const errorMessageStatusMap = new Map([
  ['failed to fetch', 503],
  ['network error', 503],
  ['fetch failed', 503],
])

export function isBrowserOffline() {
  if (typeof navigator !== 'undefined') {
    // Check if browser is offline (supplemental clue)
    return !navigator.onLine
  }
  return true
}

export function getErrorStatusAndCode(error: unknown): {
  status: number
  code: string
} {
  // Use I'm a teapot HTTP error to indicate
  // we haven't got a clue what went wrong
  let status = 418
  let code = 'unknown_error'
  if (error instanceof TypeError) {
    status =
      errorMessageStatusMap.get(error.message.toLowerCase()) ||
      status
    code = isBrowserOffline()
      ? 'offline'
      : errorMessageCodeMap.get(error.message.toLowerCase()) ||
        code
  } else if (error instanceof Error) {
    status =
      errorMessageStatusMap.get(error.message.toLowerCase()) ||
      ('code' in error && typeof error.code === 'number'
        ? error.code
        : undefined) ||
      status
    code =
      errorMessageCodeMap.get(error.message.toLowerCase()) ||
      code
  }
  return { status, code }
}

export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message as string
  } else if (typeof error === 'string') {
    return error
  } else if (
    error &&
    typeof error === 'object' &&
    'message' in error &&
    typeof error.message === 'string'
  ) {
    return error.message
  }
  return 'There has been an error'
}
